// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

import { type Scope, useScope } from "~/hooks/useScope";
import { canSetServiceAccountMembership } from "./check";

export function useCanSetServiceAccountMembership(scope?: Scope): boolean {
  const { activeScope } = useScope();
  const withinScope = scope || activeScope;
  const canDoAction =
    !!withinScope && canSetServiceAccountMembership(withinScope);
  return canDoAction;
}
